import { useMemo, useState } from 'react'

export default function CallToAction() {
  const [email, setEmail] = useState('')
  const [note, setNote] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const mailto = useMemo(() => {
    const subject = encodeURIComponent('Soulon — Partnership / Joining')
    const body = encodeURIComponent(`Email: ${email}\n\n${note}`)
    return `mailto:team@soulon.top?subject=${subject}&body=${body}`
  }, [email, note])

  return (
    <section id="cta" className="bg-hero-radial">
      <div className="container-x py-14 md:py-18">
        <div className="glass p-8 md:p-10">
          <div className="grid gap-8 md:grid-cols-12 md:items-start">
            <div className="md:col-span-6">
              <h2 className="text-2xl font-semibold tracking-tight md:text-3xl">Let’s ship this together</h2>
              <p className="mt-3 text-white/65">
                If you’re building multi-chain payments, content distribution, AI agents, or wallet experiences—or you want to help turn x402
                into an ecosystem—we’d love to talk.
              </p>
              <div className="mt-6 grid gap-3">
                <Bullet>Partnerships: payment, settlement, risk, protocol integrations</Bullet>
                <Bullet>Hiring: engineering, product, growth, design</Bullet>
                <Bullet>Co-building: open-source modules, standards, developer tools</Bullet>
              </div>
            </div>
            <div className="md:col-span-6">
              <div className="glass2 p-6">
                <div className="text-sm font-semibold text-white/90">Contact</div>
                <div className="mt-4 grid gap-3">
                  <label className="grid gap-2">
                    <span className="text-xs text-white/60">Email (optional)</span>
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      className="h-11 rounded-xl border border-white/10 bg-black/20 px-4 text-sm text-white outline-none transition focus:border-primary/40"
                    />
                  </label>
                  <label className="grid gap-2">
                    <span className="text-xs text-white/60">What do you want to discuss?</span>
                    <textarea
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      placeholder="A quick note about your background, goals, or ideas."
                      className="min-h-[110px] rounded-xl border border-white/10 bg-black/20 px-4 py-3 text-sm text-white outline-none transition focus:border-primary/40"
                    />
                  </label>
                </div>

                <div className="mt-5 flex flex-col gap-3 sm:flex-row">
                  <a
                    className="inline-flex h-11 items-center justify-center rounded-full bg-primary px-6 text-sm font-semibold text-black transition hover:bg-[#12d584]"
                    href={mailto}
                    onClick={() => setSubmitted(true)}
                  >
                    Send email
                  </a>
                  <a
                    className="inline-flex h-11 items-center justify-center rounded-full border border-white/10 bg-white/5 px-6 text-sm font-semibold text-white/85 transition hover:bg-white/10 hover:text-white"
                    href="/media"
                  >
                    Media Kit
                  </a>
                </div>
                {submitted ? (
                  <div className="mt-4 text-xs text-white/55">
                    Your email draft is ready. If you don’t have a mail client configured, copy the content and send it to team@soulon.top.
                  </div>
                ) : (
                  <div className="mt-4 text-xs text-white/45">We don’t collect or store your information on this website.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function Bullet(props: { children: string }) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white/75">
      <span className="h-2 w-2 rounded-full bg-primary" />
      <span>{props.children}</span>
    </div>
  )
}
